import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getOverallQuestion } from 'global/js/helpers';
import * as Actions from 'containers/Home/actions';
import * as tcActions from './actions';
import Header from 'components/Header/Header';
import Navigation from 'components/Navigation/Navigation';
import Question from 'components/Question/Question';
import ScaleRadioButtonList from 'components/ScaleRadioButtonList/ScaleRadioButtonList';
import StarRadioButtonList from 'components/StarRadioButtonList/StarRadioButtonList';
import TextArea from 'components/TextArea/TextArea';
import './TC.scss';

class TC extends Component {
    constructor(props) {
        super(props);
    }

    /**
     * Checks for any custom questions, and returns the link to the first
     * question or to the overall additional page.
     */
    checkCustomQuestions = () => {
        let customIndex = 0;

        // Loop over the overall questions and increment each time we see a custom one.
        for (const question of this.props.surveyData.OverallSubmission.OverallQuestions)
            if (question.Type.toLowerCase().includes('custom question'))
                customIndex++;

        return customIndex === 0 ? '/OverallAdditionalFeedback' : `/CustomQuestion/1/${customIndex}`;
    }

    /**
     * Checks for any TD questions, and returns the link to the last TD
     * question. We first count the number of TD questions. If there are
     * none, the previous page is the 'TC' page, otherwise its the custom
     * page with number of custom questions as part of the URL params.
     */
    checkTdQuestions = () => {
        let numTdQuestions = 0;

        // Loop over the overall questions and increment each time we see a TD one.
        for (const question of this.props.surveyData.OverallSubmission.OverallQuestions)
            if (question.Type.toLowerCase().includes('tourdirector'))
                numTdQuestions++;

        return numTdQuestions > 0 ? `/TD/${numTdQuestions}/${numTdQuestions}` : '/TE';
    }

	/**
	 * Called when there is a change to the text area value. Handles updating
	 * the text value state.
	 *
	 * @param    comment : {String}
	 */
    handleChange = (comment) => {
        this.props.tcActions.setOverallAnswer({
            type: 'TourConsultant',
            comment: comment
        });
    }

    render() {
        const surveyData = this.props.surveyData;
        const question = getOverallQuestion(surveyData.OverallSubmission.OverallQuestions, 'TourConsultant');
        const { Answer, AnswerType, SubText, Text, Type } = question;
        const isFourScale = AnswerType.toLowerCase().includes('4 scale');

        return (
            <section className='wrapper tc'>
                {surveyData.IsBackup && (
                    <Header customerData={surveyData.Evaluator} isOverall={true} />
                )}

                <div className='container'>
                    <h1 className="stay-name">Overall <br /> Experience</h1>
                    
                    <div className='content'>
                        <Question questionText={Text} />
						
                        {(isFourScale ?
                            <ScaleRadioButtonList
                                answerValue={Answer.AnswerRating}
                                handleClick={this.props.tcActions.setOverallAnswer}
                                isFourScale={true}
                                questionType={Type}
                            /> :
                            <StarRadioButtonList
                                answerValue={Answer.AnswerRating}
                                handleClick={this.props.tcActions.setOverallAnswer}
                                questionType={Type}
                            />
                        )}

                        <Question questionText={SubText} />

                        <TextArea 
                            handleChange={this.handleChange} 
                            textValue={Answer.AnswerComment} 
                        />
        				
                        <Navigation
                            actions={this.props.actions}
                            answerValue={Answer.AnswerRating}
                            individualID={this.props.individualID}
                            isOverall={true}
                            locationIndex={3}
                            nextLink={this.checkCustomQuestions()} 
                            prevLink={this.checkTdQuestions()} 
                            prodTourID={this.props.prodTourID}
                            surveyData={this.props.surveyData}
                        />
                    </div>
                </div>
            </section>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        individualID: state.dataReducer.individualID,
        prodTourID: state.dataReducer.prodTourID,
        surveyData: state.surveyReducer.surveyData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Actions, dispatch),
        tcActions: bindActionCreators(tcActions, dispatch)
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TC));



// WEBPACK FOOTER //
// ./application/containers/TC/TC.jsx